import * as React from 'react';
import PropTypes from "prop-types";

import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';

export class MateriasConsulta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: this.props.nombre, codigo: this.props.codigo
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = event => {
    let name = event.target.name;
    let value = event.target.value;

    if (name == "nombre") {
      this.setState({ nombre: value });
    }
    else if (name == "codigo") {
      this.setState({ codigo: value });
    }
  }

  handleSubmit = event => {
    //console.log("submit");
    event.preventDefault();
    const { url, page, size } = this.props;
    const { nombre, codigo } = this.state;
    //console.log("url = " + url + " page = " + page + " size = " + size + " nombre = " + nombre + " codigo = " + codigo);
    this.props.handle(url, page, size, codigo, nombre);
  }

  render() {
    return (
      <div>
        <form name="consulta" onSubmit={this.handleSubmit}>
            <Row key={0} className="form-group">
              <Col md={1}>
                <label className=" control-label" htmlFor="unidad">Código:</label>
              </Col>
              <Col md={4} className="w-100">
                <Input
                  type="text"
                  placeholder="Código"
                  name="codigo"
                  id="codigo"
                  defaultValue={this.state.codigo}
                onChange={this.handleChange}
                maxLength={15}
                
                >
                </Input>
              </Col>
            </Row>
          <Row key={1}>
            <Col md={1}>
              <label className=" control-label" htmlFor="programa">Nombre:</label>
            </Col>
            <Col md={4} className="w-100">
              <Input
                type="text"
                placeholder="Nombre"
                name="nombre"
                id="nombre"
                defaultValue={this.state.nombre}
                onChange={this.handleChange}
                maxLength={30}
              >
              </Input>
            </Col>
          </Row>
          <Row key={2}>
            <Col md={12}><Button type="submit">Buscar</Button></Col>
          </Row>
        </form>
      </div>
    );
  }
}

MateriasConsulta.propTypes = {
  nombre: PropTypes.any,
  codigo: PropTypes.any,
  handle: PropTypes.func
};

